import { AxiosInstance } from "axios";
import { axiosInstance, IConfig } from "./initRequest";

class HttpRequest {
  api: AxiosInstance;
  baseurl: string | undefined;
  adminurl: string | undefined;
  devadminurl: string | undefined;
  signupurl: string | undefined;
  devattendanceurl: string | undefined;
  devjobmanagementurl: string | undefined;
  websocketurl: string | undefined;
  devinventoryurl: string | undefined;
  ticketingurl: string | undefined;
  accessmanagementurl: string | undefined;
  asodao: string | undefined;
  projectmanagementurl: string | undefined;
  daourl: string | undefined;
  taskurl: string | undefined;
  notificationurl: string | undefined;
  deleteuserurl: string | undefined;
  commenturl: string | undefined;
  inventorydashboardurl: string | undefined;
  adminurlgcp: string | undefined;
  signupurlgcp: string | undefined;
  projectmanagementnewurl: string | undefined;
  procurementurl: string | undefined;
  usertrackingurl: string | undefined;
  attendanceurl: string | undefined;
  openaiservice: string | undefined;
  schedulerurl: string | undefined;
  schedulerurlV2: string | undefined;
  jobschedulerurl: string | undefined;
  webSocketController: string | undefined;
  agentchaturl: string | undefined;
  agentaudiotranscribeurl: string | undefined;
  dwytebaseurl: string | undefined;
  crowdsourceurl: string | undefined;
  agentConversationurl: string | undefined;
  agentConversationAudioTranslateUrl: string | undefined;
  agentAudioTranslateUrl:string | undefined
  webSocketFrRegistrationController:string | undefined
  broadcastUrl:string | undefined
  aetAssessmentsWebsocketUrl:string | undefined
  aetBaseUrl:string | undefined
  amtProxyUrl:string | undefined
  naPaymentTransactionsLogsWebsocketUrl:string | undefined
  


  constructor() {
    this.api = axiosInstance;
    this.baseurl = process.env.REACT_APP_API_BASE_URL;
    this.signupurl = `${this.baseurl}/signup/v1`;
    this.adminurl = `${this.baseurl}/admin-module/v1`;
    this.devadminurl = this.adminurl;
    this.devattendanceurl = `${this.baseurl}/attendance/v1`;
    this.devjobmanagementurl = process.env.REACT_APP_JOB_MANAGEMENT_URL;
    this.websocketurl = process.env.REACT_APP_JOB_MANAGEMENT_WEBSOCKET_URL;
    this.devinventoryurl = `${this.baseurl}/inventory-task/v1`;
    this.ticketingurl = `${this.baseurl}/inventory-task/v1`;
    this.accessmanagementurl = `${this.baseurl}/access-management/v1`;
    this.asodao = this.adminurl;
    this.projectmanagementurl = `${this.baseurl}/project-management/v1`;
    this.daourl = this.adminurl;
    this.taskurl = `${this.baseurl}/task-management/v1`;
    this.notificationurl = `${this.baseurl}/notification-service/v1`;

    this.deleteuserurl = `${this.baseurl}/admin-module/v1`;
    this.commenturl = `${this.baseurl}/notification-service/v1`;
    this.inventorydashboardurl = `${this.baseurl}/inventory-task/v1`;

    this.adminurlgcp = this.adminurl;
    this.signupurlgcp = this.signupurl;
    this.projectmanagementnewurl = this.projectmanagementurl;
    this.procurementurl = `${this.baseurl}/procurement-service/v1/`;
    this.attendanceurl = this.devattendanceurl;
    this.usertrackingurl = this.devattendanceurl;
    this.openaiservice = `${this.baseurl}/openai-service/v1`;
    this.schedulerurl = `${this.baseurl}/auto-scheduler/v1`;
    this.schedulerurlV2 = `${this.baseurl}/scheduler-service/v1`;
    this.jobschedulerurl = `${this.baseurl}/job-scheduler-service/v1`;
    this.webSocketController = `${this.websocketurl}/ws/amt`;
    this.agentchaturl = `${process.env.REACT_APP_AGENT_URL}`;
    this.agentaudiotranscribeurl = `${this.agentchaturl}/speech-to-text`
    // this.agentAudioTranslateUrl = `${this.baseurl}/agent-handler-service/v1/speech-to-text-translate`;
     this.agentAudioTranslateUrl = `${this.agentConversationurl}/speech-to-text-translate`;

    this.crowdsourceurl = `${this.baseurl}/crowdsource-service/v1`;
    this.agentConversationurl = `${process.env.REACT_APP_AGENT_CONVERSATION_HANDLER_URL}`;
    this.agentConversationAudioTranslateUrl = `${this.agentConversationurl}/speech-to-text-translate`;
    this.webSocketFrRegistrationController = `${this.websocketurl}/ws/amt/fr-session`;
    this.broadcastUrl = `${this.baseurl}/agent-handler-service/v1`;
    this.aetAssessmentsWebsocketUrl = `${process.env.REACT_APP_AET_ASSESSMENTS_WEBSOCKET_URL}/ws/aet-assessments`;
    this.aetBaseUrl = process.env.REACT_APP_AET_BASE_URL;
    this.amtProxyUrl = process.env.REACT_APP_AMT_PROXY_URL;

    this.naPaymentTransactionsLogsWebsocketUrl = `${process.env.REACT_APP_AET_ASSESSMENTS_WEBSOCKET_URL}/ws/payment-transactions-logs`;
  }

  async get(url: string, config?: IConfig) {
    return this.api.get(url, config);
  }

  async post(url: string, data: any, config?: IConfig) {
    return this.api.post(url, data, config);
  }

  async delete(url: string, config?: IConfig) {
    return this.api.delete(url, config);
  }
}

const httpRequest = new HttpRequest();

export default httpRequest;
